<fgb-page-header [pageTitle]="mobileTitle" [showBalance]="false"></fgb-page-header>

<div class="pt-lg-3 container">
  <fgbcl-marketplace-wallet-details [id]="id"></fgbcl-marketplace-wallet-details>
</div>
